import React, { useState, useMemo } from "react";
import { useLocation } from "react-router-dom";
import products from './data/combinedData';
import logo from "./Images/A.pTechNewLogo_4.png";
import './SearchResults.css';
import { FaWhatsapp } from 'react-icons/fa';

function SearchPage() {
    const queryParam = new URLSearchParams(useLocation().search).get("query") || "";
    const query = queryParam.trim().toLowerCase();

    const results = useMemo(() => {
        return (products || []).filter((p) => {
            if (!p || (!p.productName && !p.casNumber)) return false;
            const name = (p.productName || "").toLowerCase();
            const cas = (p.casNumber || "").toLowerCase();
            return name.includes(query) || cas.includes(query);
        });
    }, [query]);

    const ITEMS_PER_PAGE = 24;
    const [page, setPage] = useState(1);
    const [loading, setLoading] = useState(false);

    const pageCount = Math.ceil(results.length / ITEMS_PER_PAGE);
    const start = (page - 1) * ITEMS_PER_PAGE;
    const pagedResults = results.slice(start, start + ITEMS_PER_PAGE);

    const handlePageChange = (newPage) => {
        if (newPage >= 1 && newPage <= pageCount) {
            setLoading(true);
            setTimeout(() => {
                setPage(newPage);
                setLoading(false);
                window.scrollTo({ top: 0, behavior: 'smooth' });
            }, 150);
        }
    };

    return (
        <div className="search-page">
            <h2>
                <span className="Searchcount">Search Results for &quot;{queryParam}&quot;</span>
                <span className="count">({results.length})</span>
            </h2>

            {results.length === 0 ? (
                <p>No matching product found.</p>
            ) : (
                <>
                    <div className="results-scrollable">
                        {loading ? (
                            <div className="loading">Loading...</div>
                        ) : (
                            <div className="results-grid">
                                {pagedResults.map((p) => {
                                    const productSlug = `${encodeURIComponent(p.productName)}-${encodeURIComponent(p.casNumber)}`;
                                   const productLink = `${window.location.origin}/#/product/${productSlug}`;


                                    return (
                                        <div key={p.id} className="result-card">
                                            <div className="card-header">
                                                <img src={logo} alt="Product Logo" className="card-logo" />
                                                <button
                                                    className="whatsapp-button"
                                                    onClick={() => {
                                                        const message = `*Hello! I'm interested in this product*:\n\n*Name:* ${p.productName}\n\n*View Product:*\n${productLink}`;
                                                        // const message = `Hello! I'm interested in this product:\n\n*Name:* ${p.productName}\n*CAS Number:* ${p.casNumber}\n\n*View Product:*\n${productLink}`;
                                                        const phoneNumber = '9316580274';
                                                        const url = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;
                                                        window.open(url, '_blank');
                                                    }}
                                                >
                                                    <FaWhatsapp size={18} style={{ marginRight: 0 }} />
                                                </button>
                                            </div>

                                            {/* <div className="field">
                                                <span className="label">Services:</span>
                                                <Link
                                                    to={`/product/${productSlug}`}
                                                    state={{ backTo: window.location.pathname }}
                                                    className="value link"
                                                >
                                                    {p.productName}
                                                </Link>
                                            </div> */}


                                            <div className="field">
                                                <span className="label">Services:</span>
                                                <span
                                                    to={`/product/${productSlug}`}
                                                    state={{ backTo: window.location.pathname }}
                                                    className="value"
                                                >
                                                    {p.productName}
                                                </span>
                                            </div>



                                            <div className="field">
                                                <span className="label">Description:</span>
                                                <span className="value">{p.description}</span>
                                            </div>
                                        </div>
                                    );
                                })}
                            </div>
                        )}
                    </div>

                    <div className="pagination">
                        <button onClick={() => handlePageChange(page - 1)} disabled={page === 1}>‹ Prev</button>
                        {(() => {
                            const maxVisibleButtons = 7;
                            let startPage = Math.max(1, page - Math.floor(maxVisibleButtons / 2));
                            let endPage = startPage + maxVisibleButtons - 1;
                            if (endPage > pageCount) {
                                endPage = pageCount;
                                startPage = Math.max(1, endPage - maxVisibleButtons + 1);
                            }
                            const pagesToShow = [];
                            for (let p = startPage; p <= endPage; p++) {
                                pagesToShow.push(p);
                            }

                            return (
                                <>
                                    {startPage > 1 && (
                                        <>
                                            <button onClick={() => handlePageChange(1)}>1</button>
                                            {startPage > 2 && <span className="dots">...</span>}
                                        </>
                                    )}
                                    {pagesToShow.map(p => (
                                        <button
                                            key={p}
                                            onClick={() => handlePageChange(p)}
                                            className={`page-number ${p === page ? 'active' : ''}`}
                                        >
                                            {p}
                                        </button>
                                    ))}
                                    {endPage < pageCount && (
                                        <>
                                            {endPage < pageCount - 1 && <span className="dots">...</span>}
                                            <button onClick={() => handlePageChange(pageCount)}>{pageCount}</button>
                                        </>
                                    )}
                                </>
                            );
                        })()}
                        <button onClick={() => handlePageChange(page + 1)} disabled={page === pageCount}>Next ›</button>
                    </div>
                </>
            )}
        </div>
    );
}

export default SearchPage;
